var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0007,
    cy: 25.0007,
    r: 23.4955,
    fill: "#FFFEF6",
    stroke: "#D9232A",
    strokeWidth: 3.00903
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7225_9117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2192 25.5721L36.7864 25.5721L36.7864 22.4377L35.2192 22.4377L35.2192 24.0049L35.2192 25.5721ZM8.77734 24.0049L8.77734 25.5721L35.2192 25.5721L35.2192 24.0049L35.2192 22.4377L8.77734 22.4377L8.77734 24.0049Z",
    fill: "#D9232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5781 35.0636L37.0626 24.1935L25.5781 12.9473",
    stroke: "#D9232A",
    strokeWidth: 2.95888
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7225_9117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.4413,
    height: 24.2728,
    fill: "white",
    transform: "translate(8.7793 11.8643)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.b0c94af5b746d50767587af639e5d684.svg";
export { ForwardRef as ReactComponent };